import { render, staticRenderFns } from "./StepMultiChoice.vue?vue&type=template&id=fea53fe0&scoped=true&"
import script from "./StepMultiChoice.vue?vue&type=script&lang=js&"
export * from "./StepMultiChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea53fe0",
  null
  
)

export default component.exports